import { createApp } from 'vue';

interface ToastOptions {
  message?: string;
  duration?: number;
  forbidClick?: boolean;
}

const defaultOptions: Partial<ToastOptions> = {
  duration: 2000,
  forbidClick: false
};

export function showToast(options: string | ToastOptions) {
  const toastOptions = typeof options === 'string' 
    ? { ...defaultOptions, message: options }
    : { ...defaultOptions, ...options };

  const toastElement = document.createElement('div');
  toastElement.className = 'toast-message';
  toastElement.textContent = toastOptions.message || '';

  const style = document.createElement('style');
  style.textContent = `
    .toast-message {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 16px 32px;
      border-radius: 8px;
      z-index: 9999;
      font-size: 16px;
      min-width: 200px;
      max-width: 80%;
      text-align: center;
      word-break: break-all;
      animation: fadeInOut ${toastOptions.duration}ms ease-in-out;
    }

    @keyframes fadeInOut {
      0% { opacity: 0; }
      10% { opacity: 1; }
      90% { opacity: 1; }
      100% { opacity: 0; }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(toastElement);

  setTimeout(() => {
    document.body.removeChild(toastElement);
    document.head.removeChild(style);
  }, toastOptions.duration);
}

// 显示加载toast
export function showLoadingToast(options: string | ToastOptions) {
  const toastOptions = typeof options === 'string' 
    ? { ...defaultOptions, message: options, duration: 0 }
    : { ...defaultOptions, ...options, duration: 0 };

  const toastElement = document.createElement('div');
  toastElement.className = 'toast-loading';
  toastElement.id = 'loading-toast';
  
  const spinner = document.createElement('div');
  spinner.className = 'toast-spinner';
  
  const message = document.createElement('div');
  message.textContent = toastOptions.message || '';
  
  toastElement.appendChild(spinner);
  toastElement.appendChild(message);

  const style = document.createElement('style');
  style.textContent = `
    .toast-loading {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 24px;
      border-radius: 8px;
      z-index: 9999;
      font-size: 14px;
      min-width: 120px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    
    .toast-spinner {
      width: 32px;
      height: 32px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      border-top-color: white;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }
    
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(toastElement);

  return { close: () => closeToast() };
}

// 关闭toast
export function closeToast() {
  const loadingToast = document.getElementById('loading-toast');
  if (loadingToast) {
    document.body.removeChild(loadingToast);
  }
}